__turbopack_context__.v({
  "bar": "cashback-bar-module__9AtJ7a__bar",
  "bid": "cashback-bar-module__9AtJ7a__bid",
  "browse": "cashback-bar-module__9AtJ7a__browse",
  "copy": "cashback-bar-module__9AtJ7a__copy",
  "cta": "cashback-bar-module__9AtJ7a__cta",
  "icon": "cashback-bar-module__9AtJ7a__icon",
  "iconImg": "cashback-bar-module__9AtJ7a__iconImg",
  "limited": "cashback-bar-module__9AtJ7a__limited",
  "line": "cashback-bar-module__9AtJ7a__line",
  "list": "cashback-bar-module__9AtJ7a__list",
  "long": "cashback-bar-module__9AtJ7a__long",
  "row": "cashback-bar-module__9AtJ7a__row",
  "status": "cashback-bar-module__9AtJ7a__status",
});
